module.exports = __webpack_public_path__ + "static/img/27.de5f861.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/27.jpg
// module id = eyuX
// module chunks = 0